<template>
  <Home />
</template>
<script setup>
import Home from '../../views/Home.vue';
</script>
